<script lang="ts">
  /* A range input, sized for a finger.
   *
   * ═══ THE ELEMENT'S HEIGHT IS THE HIT AREA ═══
   *
   * A slider is DRAGGED, and the browser hit-tests the TRACK — so height on the
   * element is what makes the thumb catchable. A 16 px track is a thumb you have
   * to aim at while the boat moves, and this is the exact rule the layers panel
   * lost in landscape: its 44 px block was keyed on `(max-width: 640px)`, a
   * phone held sideways is 852 px wide, and the opacity sliders stayed 16 px
   * tall with the fix sitting three rules above looking correct.
   *
   * Keyed on the POINTER here, which is the question actually being asked.
   */
  let {
    value,
    min = 0,
    max = 1,
    step = 0.05,
    label,
    oninput
  }: {
    value: number;
    min?: number;
    max?: number;
    step?: number;
    /** For screen readers. "Canadian charts opacity" — the thing and the
     *  property, because "opacity" alone in a list of twelve layers says
     *  nothing about which one. */
    label: string;
    oninput?: (v: number) => void;
  } = $props();
</script>

<input
  class="slider"
  type="range"
  {min}
  {max}
  {step}
  {value}
  aria-label={label}
  oninput={(e) => oninput?.(Number(e.currentTarget.value))}
/>

<style>
  .slider {
    width: 100%;
    height: var(--h-md);
    margin: 0;
    /* `accent-color` is inherited from `:root` in theme.css. Left unset a
       dragged slider renders in the browser's own blue — a colour in the
       interface that nobody chose, under a teal list of layers. */
  }
  @media (pointer: coarse) {
    .slider {
      height: var(--h-touch);
    }
  }
</style>
